@import '~style-sheet-helpers/core.less';
@import '../../../../../../../constants/spacing.module.less';

.banner-container {
  width: 100%;
  padding: @space-24 @space-64;
  border-top: 1px solid var(--grey-300);
  justify-content: space-between;
  align-items: center;
  background: var(--default--background-color--1);
}

.close-button {
  display: flex;
  align-items: center;
  gap: @space-8;

  svg {
    height: 16px;
    width: 16px;
  }
}

.submit-button {
  min-width: 120px;
}

.loading-indicator {
  height: 65px;
  width: 65px;
  justify-self: center;
}
